import {useMapZoomLevelContext} from "@ui/leafletCustom/context/mapContext/hooks/useMapZoomLevelContext";

export function useGetMapZoomLevelFromContext() {
    return useMapZoomLevelContext()
}


